import { NS_SERVICES, API, SPRINT } from 'redux/constants';
import { createType, FETCH } from 'redux-create-type';
import { fetchCreator } from 'redux/helpers';


export const {
  GET_LIST,
  GET,
  GET_TEMPLATE,
  GET_USERS,
  UPSERT,
  COMPLETE,
  ACTIVATE
} = createType(NS_SERVICES, API, SPRINT)({
    GET_LIST: FETCH,
    GET: FETCH,
    GET_TEMPLATE: FETCH,
    GET_USERS: FETCH,
    UPSERT: FETCH,
    COMPLETE: FETCH,
    ACTIVATE: FETCH
  });

export const getList = fetchCreator(GET_LIST);
export const get = fetchCreator(GET);
export const getTemplate = fetchCreator(GET_TEMPLATE);
export const getUsers = fetchCreator(GET_USERS);
export const upsert = fetchCreator(UPSERT);
export const complete = fetchCreator(COMPLETE);
export const activate = fetchCreator(ACTIVATE);



// WEBPACK FOOTER //
// ../redux/store/services/api/configuration/sprint/actions.js